<dx-date-box valueChangeEvent="keyup" (onValueChanged)="onValueChanged($event)" (onBlur)="onTouched()"
  [readOnly]="readonly()" [isValid]="isValid" [value]="value()" [type]="type()" [disabled]="disabled()"
  [min]="minDate()" [max]="maxDate()" [inputAttr]="inputAttr()" [interval]="timeInterval()"
  [displayFormat]="displayFormat()" [showClearButton]=" true" [useMaskBehavior]="true"></dx-date-box>